<template>
  <div class="m-event-list">
    <template v-for="(event, index) in list">
      <template v-if="isShowMarketLine">
        <template v-if="!isSameDate(event, index)">
          <MarketLine
            v-if="marketInfo"
            :key="`${event.startTime}-${index}`"
            :market-titles="marketInfo.titles"
            :current-market-id="currentMarketId"
            :label="getDate(event.startTime)"
            :presentation-type="marketInfo.presentationType"
            :guide="marketInfo.guidance"
          />
        </template>
      </template>

      <Match
        v-if="marketInfo"
        :key="event.eventId"
        :event="event"
        :current-market-id="currentMarketId"
        :is-show-tournament-info="isShowTournamentInfo"
        :presentation-type="marketInfo.presentationType"
        :outcome-size="marketInfo.outcomeNumber"
        :market-titles="marketInfo.titles"
        :market-ids="marketIds"
        :oddsfiltered="oddsfiltered"
        :keyword="keyword"
        :key-points="keyPoints"
      />
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { computed } from '@vue/composition-api'
import { isSameDay } from '@ms/utils/time'
import { getMarketInfo, getSuperMarketInfo, getMarketIds } from '@ms/components/match/marketBus.js'
import useMoreMarket from 'composables/match/useMoreMarket.js'
import Match from './Match'
import MarketLine from './EventList/pagelet/MarketLine'

export default {
  name: 'CommonMatchList',
  components: {
    MarketLine,
    Match
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isShowTournamentInfo: {
      type: Boolean,
      default: true
    },
    isShowMarketLine: {
      type: Boolean,
      default: true
    },
    currentMarketId: {
      type: [String, Number],
      default: ''
    },
    // 是否需要筛选 odds
    oddsfiltered: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: String,
      default: ''
    },
    keyPoints: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { isSpecialMarket } = useMoreMarket()
    const { sportId } = props.list[0] || {}
    // 这里取巧一下，根据数值大小判断
    const isSuperMarket = computed(() =>
      isSpecialMarket({
        sportId,
        marketId: props.currentMarketId
      })
    )
    const marketInfo = computed(() => {
      if (isSuperMarket.value) {
        return getSuperMarketInfo(sportId, props.currentMarketId)
      } else {
        return getMarketInfo(sportId, props.currentMarketId)
      }
    })
    const marketIds = computed(() => {
      const ids = getMarketIds(sportId)
      return ids.includes(props.currentMarketId) ? ids : [props.currentMarketId]
    })

    return {
      marketInfo,
      marketIds,
      isSuperMarket
    }
  },
  methods: {
    getDate(startTime) {
      return dayjs(startTime).format('DD/MM dddd')
    },
    isSameDate(cur, index) {
      if (index === 0) return false
      const nextEvent = this.list[index - 1]
      return isSameDay(cur.startTime, nextEvent.startTime)
    }
  }
}
</script>
